import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetChatRating($id: ID!) {
    chat(id: $id) {
      id
      rating
      expert {
        id
        name
        photoUrl
      }
    }
  }
`);
